import React from 'react'
import { useUser } from '../../context/useUser'
function Header() {
    const { country } = useUser()
    return (
        <>
            <header className={`${country === "PK" ? "bg-[#e8d5d3]" : "bg-[#fafaeb]"} h-[40px] w-full flex justify-center items-center`}>
                <h1 className={`${country === "PK" ? "text-[#912c24]" : "text-[#65754d]"} text-[15px] font-[500]`}>
                    Free Delivery <span className='text-[#2e2a2a] text-[13px]'>on all Qurbani orders</span>
                </h1>
            </header>
            <div className="w-full overflow-hidden bg-yellow-100 py-2 relative">
                <div className="flex justify-between w-full whitespace-nowrap animate-marquee">
                    <span className="text-[#b10a0a] font-semibold text-sm px-4">
                        ⚠️ We are currently only accepting Qurbani orders for 2025. All other services will resume between July 20 and July 25. Stay tuned!
                    </span>
                </div>
            </div>
        </>
    )
}

export default Header